<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="_notificationTemplates">

          <template slot="header" vs-justify="flex-end">
            <router-link :to="{name: 'master-notificationTemplate-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('MasterNotificationTemplate', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="name">{{ $t("sections.master.dataForm.notiTempName") }}</vs-th>
            <vs-th sort-key="title">{{ $t("sections.master.dataForm.notiTempTitle") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.master.dataForm.status") }}</vs-th>
            <vs-th sort-key="default">{{ $t("sections.master.dataForm.default") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="index"  v-for="(row, index) in data">
              <vs-td>
                {{ row.name }}
              </vs-td>
              <vs-td>
                {{ row.title }}
              </vs-td>
              <vs-td>
                <vs-chip :color="getStatusColor(row.status)" class="product-order-status">{{ row.status }}</vs-chip>
              </vs-td>
              <vs-td :data="row.isChoose">
                <vs-switch color="success" v-model="isChoose" :vs-value="row.id" icon-pack="feather" vs-icon="icon-check" />
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <router-link :to="{ name: 'master-notificationTemplate-edit', params: {id: row.id } }" >
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('MasterNotificationTemplate', 'edit', 'b')"></vs-button>
                  </router-link>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('MasterNotificationTemplate', 'delete', 'b')" @click="del(row.id);" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')

export default {
  async created () {
    const vm = this
    const { getNotificationTemplates } = vm;
    await getNotificationTemplates();
    vm.pms ('MasterNotificationTemplate', 'visible', 'r')
    const obj = vm.notificationTemplates.find(res => res.isChoose === true)
    vm.isChoose = ( obj ? [obj.id] : [])
    vm.tableName = 'notificationTemplate'
  },
  computed: {
    ...mapMasterState(['notificationTemplates', 'status']),
    _notificationTemplates () {
      if(this.notificationTemplates.length === 0) return []
      return this.notificationTemplates;
    }
  },
  methods: {
    ...mapMasterActions(['getNotificationTemplates', 'deleteNotificationTemplate']),
    async del (id) {
      const vm = this;
      const {deleteNotificationTemplate} = vm;
      const {dialog} = vm.$vs
      dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteNotificationTemplate({
            form: {
              id
            },
            vm
          })
        }
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
